import { QrScanner } from "@yudiel/react-qr-scanner";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setShowBarcodeScannerModal } from "../../store/slices/appSlice";

function BarcodeScannerModal(props: any) {
    const dispatch = useAppDispatch();
    const showBarcodeScannerModal = useAppSelector((state) => state.app.showBarcodeScannerModal);
    const selectedAnimal = useAppSelector((state) => state.app.selectedAnimal);
    const handleBarcodeChange = props.handleBarcodeChange;

    const toggleBarcodeScannerModal = () => {
        dispatch(setShowBarcodeScannerModal(!showBarcodeScannerModal));
    }

    const handleReadBarcode = (result: string) => {
        console.log(result);
        handleBarcodeChange(selectedAnimal, result);
        dispatch(setShowBarcodeScannerModal(false));
    };

    return (
        <Modal isOpen={showBarcodeScannerModal} toggle={toggleBarcodeScannerModal}>
            <ModalHeader toggle={toggleBarcodeScannerModal }></ModalHeader>
            <ModalBody>
                <QrScanner
                    onDecode={(result) => handleReadBarcode(result)}
                    onError={(error) => console.log(error?.message)}
                />
            </ModalBody>
        </Modal>
    );
}

export default BarcodeScannerModal;